"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports["default"] = exports.availableProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _selectors = require("../Theme/selectors");
var _template = _interopRequireDefault(require("./template"));
var _excluded = ["colorOne", "colorTwo"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Video = function Video(_ref) {
  var colorOne = _ref.colorOne,
    colorTwo = _ref.colorTwo,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_template["default"], _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {
        one: {},
        two: {}
      };
      if (colorOne) {
        style.one.fill = (0, _selectors.getColor)(uiTheme, colorOne);
      }
      if (colorTwo) {
        style.two.fill = (0, _selectors.getColor)(uiTheme, colorTwo);
      }
      return /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
        style: style.one,
        d: "M20,4 C11.168,4 4,11.168 4,20 C4,28.832 11.168,36 20,36 C28.832,36 36,28.832 36,20 C36,11.168 28.832,4 20,4 Z"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        style: style.two,
        points: "16.8 27.2 16.8 12.8 26.4 20"
      }));
    }
  }));
};
Video.defaultProps = {
  colorOne: null,
  colorTwo: null
};
var _default = exports["default"] = Video;
var name = exports.name = 'Video';
var availableProps = exports.availableProps = ['color'];